import { useEffect } from 'react';
import BlogDetBread from '../components/blogdetails/BlogDetBread';
import BlogPost from '../components/blogdetails/BlogPost';

function BlogDetailsPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  
  return (
    
        <main>
        
         <BlogDetBread/> 
          <BlogPost/>
        </main>

  )
}

export default BlogDetailsPage;
